module.exports = __webpack_public_path__ + "static/img/4.5447f5c5.png";